
export class CommonConFig{

    BUTTON_FORM: any;
    REGEX_STR_TO_DDMMYYYY: any;
    REGEX_FORMAT_QUANTITY: any;
    REGEX_SPECIAL_CHARACTER: any;
	PAGE_SIZE_LIST: number[];

    constructor(){
        this.BUTTON_FORM = {
            
            BACK:{
                title: 'Trở lại',
                color: 'default',
                icon : '',
                toolTip: 'Trở lại',
                KeyCombine: {
                    description: 'Escapse',
                    keycode: 0,
                }
            },
            SAVE_TMP: {
                title: 'Lưu tạm',
                color: 'tmp',
                icon : '',
                toolTip: 'Lưu tạm',
                KeyCombine: {
                    description: 'Alt + T',
                    keycode: 84,
                }
            },
            SAVE: {
                title: 'Gửi',
                color: 'accent',
                icon : 'check_circle',
                toolTip: 'Gửi',
                KeyCombine: {
                    description: '',
                    keycode: 0,
                }
            },
            SAVE_AND_CLOSE : {
                title: 'Gửi và trở lại',
                color: 'accent',
                icon : 'check_circle',
                toolTip: 'Gửi và trở lại',
                KeyCombine: {
                    description: 'Alt + S',
                    keycode: 83,
                }
            },
            SAVE_AND_NEW : {
                title: 'Gửi và thêm mới',
                color: 'primary',
                icon : '',
                toolTip: 'Lưu và trở lạ',
                KeyCombine: {
                    description: 'Alt + B',
                    keycode: 66,
                }
            },
            NOT_CONFIRM : {
                title: 'Không duyệt',
                color: 'warn',
                icon : '',
                toolTip: 'Không duyệt',
                KeyCombine: {
                    description: 'Alt + R',
                    keycode: 82,
                }
            },
            THONGKE : {
                title: 'Thống kê',
                color: 'info',
                icon : 'insert_invitation',
                toolTip: 'Thống kê',
                KeyCombine: {
                    description: 'Alt + C',
                    keycode: 67,
                }
            },
            CONFIRM : {
                title: 'Duyệt',
                color: 'primary',
                icon : '',
                toolTip: 'Duyệt',
                KeyCombine: {
                    description: 'Alt + X',
                    keycode: 88,
                }
            },
            DENY : {
                title: 'Từ chối',
                color: 'warn',
                icon : '',
                toolTip: 'Từ chối',
                KeyCombine: {
                    description: 'Alt + R',
                    keycode: 82,
                }
            },
            OK : {
                title: 'Xác nhận',
                color: 'primary',
                icon : '',
                toolTip: 'Xác nhận',
                KeyCombine: {
                    description: 'Alt + X',
                    keycode: 88,
                }
            },
            IMPORT : {
                title: 'Import file',
                color: 'info',
                icon : '',
                toolTip: 'Import file',
                KeyCombine: {
                    description: 'Alt + I',
                    keycode: 73,
                }
            },
            EXPORT : {
                title: 'Xuất Excel',
                color: 'primary',
                icon : 'cloud_download',
                toolTip: 'Xuất Excel',
                KeyCombine: {
                    description: 'Alt + P',
                    keycode: 80,
                },
                titleLoading: '... Đang xuất Excel'
            },
            IMPORT_TEMPLATE : {
                title: 'Tải File mẫu',
                color: 'accent',
                icon : 'vertical_align_bottom',
                toolTip: 'Tải File mẫu',
                KeyCombine: {
                    description: '',
                    keycode: 0,
                }
            },
            
            DA_XONG: {
                title: 'Đã xong',
                color: 'tmp',
                icon : '',
                toolTip: 'Đã xong',
                KeyCombine: {
                    description: 'Alt + E',
                    keycode: 69,
                }
            },

            APPLY: {
                title: 'Áp dụng',
                color: 'accent',
                icon : '',
                toolTip: 'Áp dụng',
                KeyCombine: {
                    description: 'Alt + Q',
                    keycode: 81,
                }
            },
            APPLY_NEW: {
                title: 'Áp dụng & Thêm mới',
                color: 'primary',
                icon : '',
                toolTip: 'Áp dụng & Thêm mới',
                KeyCombine: {
                    description: 'Alt + W',
                    keycode: 87,
                }
            },

            THUGON: {
                title: 'Thu gọn',
                color: 'tmp',
                icon : '',
                toolTip: 'Thu gọn',
                KeyCombine: {
                    description: 'Alt + K',
                    keycode: 75,
                }
            },
            MORONG: {
                title: 'Mở rộng',
                color: 'tmp',
                icon : '',
                toolTip: 'Mở rộng',
                KeyCombine: {
                    description: 'Alt + M',
                    keycode: 77,
                }
            },
            

        },
        this.REGEX_STR_TO_DDMMYYYY = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/g
        this.REGEX_FORMAT_QUANTITY = '^(([1-9][0-9]{0,2},([0-9]{3},)*)[0-9]{3}(\.[0-9]{1,})?|([1-9]([0-9]+)?)(\.[0-9]{1,})?|[0](\.([1-9][0-9]?|[0][1-9])))$'
        this.REGEX_SPECIAL_CHARACTER = /[a-zA-Z -!$%^&*()_+|~=`{}[:;<>?@#\]]/g;
    }

}